import { captureException } from "@sentry/browser";
import { AxiosError, AxiosResponse, isAxiosError, isCancel } from "axios";
import z, { ZodSchema } from "zod";
import { CommonErrorResponse } from "./agentTypes";

export const softValidateResponse =
  <T extends ZodSchema>(schema: T) =>
  async (response: AxiosResponse | AxiosError) => {
    if (isAxiosError(response) && isCancel(response)) {
      const error = {
        result: false,
      } as CommonErrorResponse;

      return {
        ...response,
        data: error,
      } as unknown as AxiosResponse<CommonErrorResponse>;
    }
    const parsed = await schema.safeParseAsync(response.data);

    if (!parsed.success) {
      const message = "Ошибка валидации ответа API";
      const url = response.config.url;
      const payload = {
        url,
        response: response.data,
        error: parsed.error,
      };
      captureException(message, {
        extra: payload,
      });
      console.error(message, payload);
    }

    return response as AxiosResponse<z.infer<T>>;
  };
